export enum Positions {
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom',
  Left = 'left',
}
